import Links from './Links.vue';

// @ts-ignore
Links.install = (Vue) => {
  Vue.component((Links as any).options.name, Links);
};

export default Links;
